import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

/**
 * FOR-48 (BU-10) 10d — firm-wide portal settings (subdomain/domain, default flags,
 * email infra, phase-status flag). Proxies through graphql/ to the portal internal
 * admin API. No forecast_db write.
 */
const mutation = graphql`
	mutation updateFirmPortalSettingsMutation($input: UpdateFirmPortalSettingsInput!) {
		updateFirmPortalSettings(input: $input) {
			firmPortalSettings {
				portalSubdomain
				portalCustomDomain
				portalReplyTo
				defaultAllowFileUpload
				phaseStatusEnabled
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return trackAndCommitMutation(environment, {mutation, variables, onCompleted: onSuccess, onError}, true);
}

export default {commit};
